import { collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const deleteThemeTag = async (themeTagId: string) => {
  const collectionRef = collection(db, "themeTags");

  await deleteDoc(doc(collectionRef, themeTagId));
};
